export default __webpack_public_path__ + "static/media/manage_payments.41f64ea2.svg";